import React, { useEffect, useState } from "react";
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";
import { getPracticeLocations } from "../../apracticeidapi";

export function BookingSummary({ selectedPractice }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyByjBdnclLYyD29eTgLlI5ajoHvA_Wn8xI",
    libraries: ["places"],       // ensures maps+markers load correctly
  });

  const [location, setLocation] = useState(null);

  useEffect(() => {
    if (!selectedPractice) return;
    getPracticeLocations([selectedPractice.practiceNumber])
      .then(locs => {
        if (locs.length && locs[0].lat != null) {
          setLocation({
            lat: parseFloat(locs[0].lat),
            lng: parseFloat(locs[0].lng),
          });
        } else {
          setLocation(null);
        }
      })
      .catch(() => setLocation(null));
  }, [selectedPractice]);

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading map…</p>;
  if (!location) return <p>No map data</p>;

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "400px" }}
      center={location}
      zoom={15}
    >
      <MarkerF position={location} />
    </GoogleMap>
  );
}
